<template>
  <div
    class="w-full"
    :class="[
      showValidationErrors && required && selection === ''
        ? 'relative mb-5'
        : 'mb-2',
    ]"
  >
    <div
      v-if="question?.show_subject !== false"
      class="flex items-start"
    >
      <p
        v-if="!question?.is_html_subject"
        class="text-dark-blue"
      >
        {{ subject }}
      </p>
      <div
        v-else
        class="text-sm"
        v-html="question?.subject"
      />
      <slot />
    </div>
    <p class="mb-1 text-xxs font-bold uppercase text-gray-over-dark">
      {{ question.description }}
    </p>
    <div
      class="mt-4 grid gap-2 sm:grid-cols-2"
      :class="[
        showValidationErrors && required && !(selection === '') ? 'mb-5' : '',
      ]"
    >
      <div
        v-for="option in orderedOptions"
        :key="option"
        class="mb-2 w-full md:mb-0"
      >
        <round-radio-button
          custom-class="text-xs sm:text-sm"
          :item="option.value"
          :value="option.id"
          :name="'radio_' + question_id"
          :checked="option.id === selection"
          :display-as-required="
            selection === '' && required && showValidationErrors
          "
          :handle-click="handleClick"
        />
      </div>
    </div>
    <div
      v-if="showValidationErrors && required && selection === ''"
      class="absolute -bottom-5 pl-1 text-3xs text-red-500"
    >
      This field is required.
    </div>
  </div>
</template>

<script>
import RoundRadioButton from '@/components/RoundRadioButton.vue';
import _ from 'lodash';

export default {
  name: 'Radio',
  components: {
    RoundRadioButton,
  },
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    currentTaxFormId: Number,
    onboardingPacketId: Number,
    setTaxAnswers: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
    currentAnswerObject: [Object, Boolean],
  },
  // watch: {
  //     currentAnswerObject: {
  //         handler: function (newVal) {
  //             let self = this;
  //             if (newVal && newVal !== false && newVal?.id > 0 && self.selection == '') {
  //                 console.log('currentAnswerObject watch -> id: ' + newVal.id + ' | selection: ' + self.selection);
  //                 console.dir(newVal);
  //                 self.selection = newVal?.answer_options?.[0]?.tax_question_option_id;
  //                 if (self.question?.options?.length > 0) {
  //                     self.defaultSelection = self.question.options.filter(el => (el.id == self.selection))[0];
  //                 }
  //                 if (self.selection) {
  //                     self.emitForComparison(self.selection);
  //                 }
  //             }
  //         },
  //         deep: true
  //     }
  // },
  emits: ['child-check', 'group-check'],
  data() {
    return {
      selection: '',
    };
  },
  computed: {
    orderedOptions() {
      return _.orderBy(this.question.options, 'order');
    },
    currentTaxForm() {
      return this.$store.state.taxQuestions.current_tax_form;
    },
    showValidationErrors() {
      if (this.currentTaxForm?.length < 1) return false;
      return this.$store.state.taxQuestions.show_validation_errors[
        this.currentTaxForm
      ];
    },
  },
  created() {
    if (this.currentAnswerObject && this.currentAnswerObject !== false) {
      this.selection =
        this.currentAnswerObject?.answer_options?.[0]?.tax_question_option_id;
      if (this.question?.options?.length > 0) {
        this.defaultSelection = this.question.options.filter(
          (el) => el.id == this.selection
        )[0];
      }
      if (this.selection) {
        this.presetSavedAnswer();
      }
    }
  },
  methods: {
    handleClick(e) {
      this.selection = parseInt(e.target.value);

      let body = null;
      if (this.selection) {
        body = {
          onboarding_packet_id: this.onboardingPacketId,
          tax_form_id: this.currentTaxFormId,
          tax_question_id: this.question_id,
          tax_answer_options_attributes: [
            { tax_question_option_id: this.selection },
          ],
        };
      }

      this.setTaxAnswers(body);
      if (this.required) {
        this.selection
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.selection);
    },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (child?.evaluation_js?.length > 0 && child?.tax_question_id > 0) {
            this.$emit(
              'child-check',
              child.tax_question_id,
              value,
              child.evaluation_js,
              child.is_shown_by_default,
              child.is_required
            );
          }
        });
      }
      if (this.question?.group_parent_id !== null) {
        this.$emit(
          'group-check',
          this.question?.id,
          this.question?.group_parent_id,
          value
        );
      }
    },
    presetSavedAnswer() {
      let body = {
        onboarding_packet_id: this.onboardingPacketId,
        tax_form_id: this.currentTaxFormId,
        tax_question_id: this.question_id,
        tax_answer_options_attributes: [
          { tax_question_option_id: this.selection },
        ],
      };

      this.setTaxAnswers(body);
      if (this.required) {
        this.selection
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.selection);
    },
  },
};
</script>
